const teamMembers = document.querySelectorAll('.team-member');

teamMembers.forEach(member => {
    const btn = member.querySelector('.btn[data-target]');
    if (!btn) return;

    btn.addEventListener('click', (e) => {
        e.preventDefault();
        const target = btn.dataset.target;
        const overlay = member.querySelector(`[data-value="${target}"]`);
        if (!overlay) return;

        const isActive = overlay.classList.toggle('active');
        btn.textContent = isActive ? 'Close' : 'Read More';
    });
});